import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { ApiEndpointService } from './api-endpoint.service';

export interface IWebContentDataRecord {
  Link: string;
  Name: string;
}

export interface IWebContentData {
  LandingPageList: IWebContentDataRecord[];
  ProfileList: IWebContentDataRecord[];
  SubscriptionList: IWebContentDataRecord[];
  SurveyList: IWebContentDataRecord[];
}

@Injectable()
export class WebContentDataApi {

  constructor(private httpService: HttpService,
    private apiEndpoint: ApiEndpointService) {
  }

  getWebContentData() {
    return this.httpService.get(this.apiEndpoint.WebContentUrl);
  }

}

